var map = {
	"./en/alcoholic.json": [
		228,
		228
	],
	"./en/coffee.json": [
		78,
		78
	],
	"./en/nonAlcoholic.json": [
		234,
		853
	],
	"./mk/alcoholic.json": [
		71,
		71
	],
	"./mk/coffee.json": [
		127,
		127
	],
	"./mk/nonAlcoholic.json": [
		64,
		64
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 931;
module.exports = webpackAsyncContext;